module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "pageno",
    attrs: {
      "id": "Page_1",
      "title": "- 1 -"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "figcenter"
  }, [_c('img', {
    attrs: {
      "alt": "Decoration",
      "height": "133",
      "src": "Images/003.jpg",
      "title": "",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h1', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00023"
    }
  }, [_vm._v("OUT ON THE PAMPAS;")]), _vm._v(" "), _c('h5', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("OR,")]), _vm._v(" "), _c('h2', {
    staticClass: "sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00024"
    }
  }, [_vm._v("THE YOUNG SETTLERS.")]), _vm._v(" "), _c('p', {
    staticClass: "center xsmfont"
  }, [_vm._v("——♦——")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72d58b0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/main_0003.vue
// module id = 66
// module chunks = 0